import React from 'react';

function Score({ score, total, onPlayAgain }) {
  const percentage = (score / total) * 100;
  
  const getStars = () => {
    if (percentage >= 80) return '⭐⭐⭐';
    if (percentage >= 60) return '⭐⭐';
    return '⭐';
  };

  const getMessage = () => {
    if (percentage === 100) return 'Perfect! You\'re a genius! 🎉';
    if (percentage >= 80) return 'Excellent work! 🌟';
    if (percentage >= 60) return 'Great job! Keep it up! 👍';
    if (percentage >= 40) return 'Good try! Practice more! 💪';
    return 'Keep learning! You can do it! 🚀';
  };

  return (
    <div className="score-container">
      <h1 className="score-title">Quiz Complete!</h1>
      
      <div className="score-display">
        {score} / {total}
      </div>

      <div className="stars">
        {getStars()}
      </div>

      <p className="score-message">
        {getMessage()}
      </p>

      <button className="play-again-btn" onClick={onPlayAgain}>
        🎮 Play Again
      </button>
    </div>
  );
}

export default Score;
